const GTM_ITEM_XML_CATEGORIES = {
  addon: 'ADDON',
  diet: 'DIET',
  dish: 'DISH',
};

export default GTM_ITEM_XML_CATEGORIES;
